import http from '@/services/api/http';

export default {
  getContracts() {
    const url = process.env.USE_API_WRAPPER ?
      'api/Public/GetLiveData?url=/api/Public/MapDataLegend/EC' :
      'api/Public/MapDataLegend/EC';

    return http.get(url);
  },
  getStateData() {
    const url = process.env.USE_API_WRAPPER ?
      'api/Public/GetLiveData?url=/api/Public/MapData/EC' :
      'api/Public/MapData/EC';

    return http.get(url);
  },
  getContractsSenate() {
    const url = process.env.USE_API_WRAPPER ?
      'api/Public/GetLiveData?url=/api/Public/MapDataLegend/SEN' :
      'api/Public/MapDataLegend/SEN';

    return http.get(url);
  },
  getStateDataSenate() {
    const url = process.env.USE_API_WRAPPER ?
      'api/Public/GetLiveData?url=/api/Public/MapData/SEN' :
      'api/Public/MapData/SEN';

    return http.get(url);
  },
};



// WEBPACK FOOTER //
// ./src/services/api/map.js